import api from '@pray/shared/utils/api';

import type { WarmupCampaignDashboard } from './types';

export async function getWarmupCampaignDashboard({
  artistId,
  warmupId,
}: {
  artistId: string;
  warmupId: string;
}): Promise<WarmupCampaignDashboard> {
  if (!artistId) throw new Error('Artist ID is required');
  if (!warmupId) throw new Error('Warmup ID is required');

  const url = `/web/studio/artists/${artistId}/warmup-campaigns/${warmupId}/dashboard`;
  const response = await api.executeGetRequest<{ data: { object: WarmupCampaignDashboard } }>(url);
  return response.data.data.object;
}
